import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import CollectionSelect from 'components/settings/projectConfiguration/reviewFrequency/components/CollectionSelect';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <CollectionSelect {...wrappedProps} />
    </AppWrapper>
  );
}
